// Ensure @calcom/embed-react is installed:
// npm install @calcom/embed-react

const { default: Cal, getCalApi } = require("@calcom/embed-react");
const { useEffect, useState } = require("react");


const defaultProps = {
    namespace: "15min",
    calLink: "naveen-sharma-iydx9h/15min",
    layout: "month_view",
};

const CalComponent = (props) => {
    const { namespace, calLink, layout } = { ...defaultProps, ...props };
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const cal = await getCalApi({ namespace });
                if (mounted) {
                    cal("ui", { hideEventTypeDetails: false, layout });
                    setIsLoading(false);
                }
            } catch (err) {
                if (mounted) {
                    setError("Failed to load calendar: " + (err instanceof Error ? err.message : "Unknown error"));
                    setIsLoading(false);
                }
            }
        })();

        return () => {
            mounted = false;
        };
    }, [namespace, layout]);

    if (error) {
        return (
            <div
                style={{
                    color: "red",
                    padding: "16px",
                    textAlign: "center",
                    border: "1px solid red",
                    borderRadius: "4px",
                    maxWidth: "90%",
                    margin: "16px auto",
                }}
            >
                {error}
                <p style={{ color: "#333", marginTop: "8px", fontSize: "14px" }}>
                    Note: Google’s spam policy may prevent calendar events from appearing automatically. Check your email (including spam/junk) for the invitation and click "I know the sender" to add it. Alternatively, adjust your Google Calendar settings to allow events from all senders.{" "}
                    <a
                        href="https://support.google.com/calendar/answer/2466563"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007bff" }}
                    >
                        Learn how
                    </a>
                </p>
            </div>
        );
    }

    return (
        <div style={{ width: "100%", margin: "0 auto", paddingTop: "2rem" }}>
            <Cal
                namespace={namespace}
                calLink={calLink}
                style={{ width: "100%", height: "100%", overflow: "auto" }}
                config={{ layout }}
                aria-label="Booking calendar"
            />
        </div>
    );
};

export default CalComponent;